import { supabase } from '@/integrations/supabase/client';

// Fetch tournaments for a user
export async function fetchProfileTournamentsForUser(userId: string) {
  const { data, error } = await supabase
    .from('profile_tournaments')
    .select('tournament_id, role, tournaments (name)')
    .eq('profile_id', userId);

  if (error) throw error;
  return data.map((row: any) => ({
    id: row.tournament_id,
    name: row.tournaments?.name,
    role: row.role,
  }));
}

// Assign or update a tournament role for a user
export async function assignTournamentRole(userId: string, tournamentId: string, role: string) {
  // Upsert (insert or update)
  const { error } = await supabase
    .from('profile_tournaments')
    .upsert({ profile_id: userId, tournament_id: tournamentId, role }, { onConflict: 'profile_id,tournament_id' });
  if (error) throw error;
}

// Remove a tournament role for a user
export async function removeTournamentRole(userId: string, tournamentId: string) {
  const { error } = await supabase
    .from('profile_tournaments')
    .delete()
    .eq('profile_id', userId)
    .eq('tournament_id', tournamentId);
  if (error) throw error;
}

// Fetch teams for a user
export async function fetchProfileTeamsForUser(userId: string) {
  const { data, error } = await supabase
    .from('profile_teams')
    .select('team_id, role, teams (name)')
    .eq('profile_id', userId);

  if (error) throw error;
  return data.map((row: any) => ({
    id: row.team_id,
    name: row.teams?.name,
    role: row.role,
  }));
}

// Assign or update a team role for a user
export async function assignTeamRole(userId: string, teamId: string, role: string) {
  // Upsert (insert or update)
  const { error } = await supabase
    .from('profile_teams')
    .upsert({ profile_id: userId, team_id: teamId, role }, { onConflict: 'profile_id,team_id' });
  if (error) throw error;
}

// Remove a team role for a user
export async function removeTeamRole(userId: string, teamId: string) {
  const { error } = await supabase
    .from('profile_teams')
    .delete()
    .eq('profile_id', userId)
    .eq('team_id', teamId);
  if (error) throw error;
} 